import { render } from "./Home.vue?vue&type=template&id=01b8e7de&scoped=true&bindings={}"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=01b8e7de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01b8e7de"

export default script